/* eslint-disable no-loop-func */
import { Button, Tag, Upload, Space, message } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { CgAttachment } from 'react-icons/cg';
import useFetch from '../../_fetch';
import PermissionModal from '../PermissionModal';
import { Buffer } from 'buffer';
import { user_role } from '../../consts';
import './styles.css';
import FileItem from '../FilesItem';
import { useIsPrimaryClientView } from '../../utils/useIsPrimaryClientView';


export default function Files({ setQuery, query_id, id, query, queryStatus }) {
    const [loading, setLoading] = useState(false);
    const _fetch = useFetch();
    const { _id, role } = useSelector((st) => st.user);
    const [queryFiles, setQueryFile] = useState([]);
    const [filesUpload, setFilesUpload] = useState([]);
    const [permissionModal, setPermissionModal] = useState(null);
    const uploadUrl = useRef();
      const { isReadOnly } = useIsPrimaryClientView();
    const Reload = (ev) => {
        ev.preventDefault();
        return ev.returnValue = 'Are you sure you want to close?';
    }

    const handleQueryStatusUpdate = async (update) => {
        if (update?.status === queryStatus) return;
        try {
            setLoading(true);
            let body = update;
            let updatedQuery = await _fetch(`${process.env.REACT_APP_API_URL}/query/${query_id}`, {
                method: 'PATCH',
                body,
            });
            let resJson = await updatedQuery.json();
            if (resJson.status === 200) {
                message.success('Status Updated');
                setQuery(resJson.response)
            } else {
                message.error('Status Update Failed');
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }


    const beforeUpload = async (file) => {
        try {
            const fileParts = file.name.split(".");
            fileParts.pop();
            let name = fileParts.join(".");
            let ext = file.name.split('.').pop();
            name = `${name}-${moment().valueOf()}.${ext}`
            let url = await _fetch(
                `${process.env.REACT_APP_API_URL}/file/get_upload_url?name=${name}&query=${id}`
            );
            if (url.status === 200) {

                url = await url.json();
                uploadUrl.current = url;
            } else {
                console.error('url to upload generation failed');
                throw new Error('url to upload generation failed');
            }
        } catch (e) {
            console.error(e);
        }
    };
    async function init() {
        try {
            let files = await _fetch(
                `${process.env.REACT_APP_API_URL}/file?query=${id}`
            );
            if (files.status === 200) {
                files = await files.json();
                setQueryFile(prev => [...prev, ...files.response]);
                // dispatch(storeFiles(files.response));
            }
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        init();
    }, []);

    const upload = async (data, screenShot = false) => {
        setLoading(true)
        window.addEventListener("beforeunload", Reload);
        try {
            let options;
            let contentType = "";
            // check if screenshot
            if (!screenShot) {
                let file = data.file;
                contentType = file.type;
                options = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': contentType,
                    },
                    body: file,
                };
            } else {
                // custom upload for ctrl+V screenShots ,Reason: getting Image in base64 format :AWS different way of upload for base64

                contentType = 'image/jpeg';
                try {
                    var buf = new Buffer.from(
                        data.replace(/^data:image\/\w+;base64,/, ''),
                        'base64'
                    );
                    options = {
                        method: 'PUT',
                        headers: {
                            'Content-Type': contentType,
                        },
                        body: buf,
                    };
                } catch (e) {
                    console.warn('error uploading screenshot', String(e));
                }
            }
            let res = await fetch(uploadUrl.current, options);
            if (res.status === 200) {
                try {
                    let parsedUrl = new URL(uploadUrl.current);
                    let pathname = parsedUrl.pathname.slice(1);
                    let uploadedRes = await _fetch(
                        `${process.env.REACT_APP_API_URL}/file`,
                        {
                            method: 'POST',
                            body: {
                                query: id,
                                path: pathname,
                                type: contentType
                            },
                        }
                    );

                    if (uploadedRes.status === 201) {

                        handleQueryStatusUpdate({ status: "OPEN" })
                        window.removeEventListener("beforeunload", Reload)

                        uploadedRes = await uploadedRes.json();
                        setQueryFile((f) => {
                            return [uploadedRes, ...f]
                        });
                        setLoading(false);
                        message.success('File added successfully')
                    }
                } catch (e) {
                    setLoading(false);
                    message.error(e.message)
                    console.error(e);
                }
            }
        } catch (e) {
            console.error(e);
            message.error(e.message)
        }
    };
    const deleteFile = async () => {
        try {
            let res = await _fetch(`${process.env.REACT_APP_API_URL}/file`, {
                method: 'DELETE',
                body: {
                    id: permissionModal._id,
                    user_id: _id
                }
            });
            let resJson = await res.json();
            if (resJson) {
                let newFileAfterDelete = queryFiles?.filter(data => data?._id !== permissionModal._id)
                setQueryFile(newFileAfterDelete)
                message.success('File deleted successfully');
                setPermissionModal(null);
            } else {
                console.error(resJson?.message)
                message.error(resJson?.message);
            }
        } catch (e) {
            message.error('Error deleting file');
            console.error(e);
        } finally {
            setPermissionModal(null);
        }
    }
    return (
        <div>
            <div>
                {queryFiles?.filter((s) => {
                    return s?.commentId === null
                }).length
                    ? queryFiles
                        .filter((s) => s.commentId === null)
                        .map((e, index) => {
                            return <FileItem
                                key={`comment-file-${index}`}
                                file={e} allowDelete={role === user_role.ADMIN}
                                deleteClicked={(event) => {
                                    event.stopPropagation();
                                    if (queryStatus === 'CLOSED') {
                                        message.error('Cannot delete file from closed query');
                                        return;
                                    }
                                    setPermissionModal(e);
                                }} />
                        })
                    : null}
            </div>

            <Space className='mt-2 mx-2'>
                <Upload
                    beforeUpload={beforeUpload}
                    customRequest={upload}
                    showUploadList={false}
                >
                    <Button loading={loading} icon={<CgAttachment size={15} />} className='me-1' disabled={isReadOnly} >
                        Attach File
                    </Button>

                </Upload>


                {filesUpload.map((e, index) => (
                    <Tag
                        className='pointer m-1'
                        style={{
                            padding: '4px',
                            borderRadius: '5px',
                            maxWidth: '180px',
                        }}
                        onClick={() =>
                            setFilesUpload((e) => {
                                delete e[index];
                                return e.filter((sm) => Boolean(sm));
                            })
                        }
                        key={`upload-file-${index}`}
                    >
                        <span
                            style={{ display: 'inline' }}
                            className='myDIV border'
                        >
                            {e.fileName}
                        </span>
                        {/* <AiFillCloseSquare style={{}} className='hide border' /> */}
                    </Tag>
                ))}
            </Space>
            <PermissionModal
                visible={permissionModal !== null}
                setVisible={setPermissionModal}
                onSuccess={deleteFile}
                child={
                    <p>Are you sure you want to delete this <b>Attachment</b>? </p>
                }
            />
        </div >
    );
}
